import styled from 'styled-components';
import { mediaQueries, size } from '@everlywell/leaves';

const Wrapper = styled.div`
  position: fixed;
  z-index: 11;
  top: 57px;
  left: 0;
  right: 0;
  margin: ${size.md}px;
`;
export { Wrapper };
